import { BaseWebComponent } from "./webcomponent-base";

export class SidebarFooterWebComponent extends BaseWebComponent {
    static webComponentName = "wc-sidebar-footer";
    static observedAttributes = [];
    
    constructor() {
        super();
    }
    
    render(): void {
        return ; // non c'è niente da renderizzare
    }
}

